import React from 'react';
import DraftEditor from 'components/draftEditor/DraftEditor';

const TextEditor = props => <DraftEditor {...props} />;
export default TextEditor;
